// Copyright © 2021 Move Closer
import { PopoverPositions, Triggers } from './Popover.contracts';
/**
 * @author Olga Milczek <olga.milczek@movecloser.pl>
 */
export const popoverProps = {
    position: {
        type: String,
        required: false,
        default: PopoverPositions.Bottom
    },
    triggerMode: {
        type: String,
        required: false,
        default: Triggers.Hover
    }
};
